module.exports = __webpack_public_path__ + "img/P1070860.de0464d2.jpg";